var _defs, _circle, _g, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJupiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: "35%",
    cy: "30%",
    r: "82%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f4d9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b5783a"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 96,
    fill: "url(#j)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#a5622b",
    strokeOpacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 68 h172",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 90 h180",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 108 h168",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 136 h180",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 158 h160",
    strokeWidth: 4
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122,
    cy: 106,
    rx: 22,
    ry: 13,
    fill: "#c0392b",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupiter);
export default __webpack_public_path__ + "static/media/jupiter.7e69db2295f5ea979e8042a8fb72ed9e.svg";
export { ForwardRef as ReactComponent };